import { parseDecimalInput } from '../../shared/numeric/localeNumeric';
import type { CustomerCheckDraft } from '../store/useCustomerOverlayStore';
import { formatMoney } from '../../shared/format/public-api';

export type CustomerCheckDraftsValidation = { ok: true } | { ok: false; title: string; message: string };

const TITLE = 'Datos del cheque';
const SUM_EPSILON = 0.009;

/**
 * Validación multi-cheque (Fase C): un cobro puede pagarse con 1..n cheques.
 * - Todo cheque requiere número.
 * - Con más de un cheque, cada uno requiere monto y la suma debe igualar el
 *   monto del cobro (mismo invariante que aplica el server).
 */
export function validateCustomerCheckDrafts(
  drafts: CustomerCheckDraft[],
  paymentAmount: number
): CustomerCheckDraftsValidation {
  if (drafts.length === 0 || drafts.some((d) => d.number.trim().length === 0)) {
    return { ok: false, title: TITLE, message: 'Completá el número de cada cheque.' };
  }
  if (drafts.length === 1) return { ok: true };

  const amounts = drafts.map((d) => parseDecimalInput(d.amount, { min: 0 }));
  if (amounts.some((a) => a == null)) {
    return { ok: false, title: TITLE, message: 'Completá el monto de cada cheque.' };
  }
  const sum = amounts.reduce<number>((acc, a) => acc + (a ?? 0), 0);
  if (Math.abs(sum - paymentAmount) > SUM_EPSILON) {
    return {
      ok: false,
      title: TITLE,
      message: `La suma de los cheques (${formatMoney(sum)}) tiene que ser igual al cobro (${formatMoney(paymentAmount)}).`,
    };
  }
  return { ok: true };
}
